<script setup>

/*==================================================================*/
/*================== VUE IMPORTS ===================================*/
/*==================================================================*/

import { defineProps, defineEmits } from 'vue';

/*==================================================================*/
/*================== PROPS =========================================*/
/*==================================================================*/

const props = defineProps({
    label: {
        type: String,
        default: ''
    },
    value: {
        type: String,
        default: ''
    },
    disabled: {
        type: Boolean,
        default: false
    },
    placeholder: {
        type: String,
        default: ''
    }
});

/*==================================================================*/
/*================== EMITS =========================================*/
/*==================================================================*/

const emits = defineEmits([
    'input',
]);

/*==================================================================*/
/*================== MÉTODOS =======================================*/
/*==================================================================*/

const onInput = (event) => {

    emits('input', event);
    
}

</script>

<template>

    <v-textarea
        class="c-textarea"
        :label="props.label"
        :value="props.value"
        :disabled="props.disabled"
        :placeholder="props.placeholder"
        outlined
        dense
        hide-details
        @input="onInput($event)"
    ></v-textarea>

</template>

<style scoped>

.c-textarea {
    padding: 2px;
}

</style>
